import logo from '../assets/images/logo.png';

import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { User, Lock, Eye, EyeOff } from 'react-feather';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from './Api';

function Login() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const allowedDomains = ['gmail.com', 'yahoo.com'];
    const emailValue = formData.email.trim();
    const domain = emailValue.split('@')[1]?.toLowerCase();

    if (!domain || !allowedDomains.includes(domain)) {
      toast.error('Email hanya boleh menggunakan domain gmail.com atau yahoo.com.');
      return;
    }

    // Cek karakter berbahaya (kecuali password)
    const invalidCharPattern = /[<>{}"'`$%^&*+=]/;
    if (invalidCharPattern.test(formData.email)) {
      toast.error('Email tidak boleh mengandung simbol berbahaya.');
      return;
    }

    // Field kosong
    if (formData.email.trim() === '' || formData.password.trim() === '') {
      toast.warning('Email dan Password wajib diisi.');
      return;
    }

    if (formData.password.length < 6) {
      toast.warning('Password minimal 6 karakter.');
      return;
    }

    try {
      const res = await api.post('/login', {
        email: formData.email,
        password: formData.password,
      });

      const token = res.data.access_token;
      const user = res.data.user;

      const allowedRoles = [1, 2, 3, 5, 6, 7];
      if (!allowedRoles.includes(user.role_id)) {
        toast.error('Akses ditolak. Akun Anda tidak memiliki izin login.');
        return; // Stop di sini
      }

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      toast.success('Login berhasil!');
      navigate('/welcome');
    } catch (err) {
      console.error('Login gagal:', err.response?.data || err.message);
      toast.error('Login gagal. Periksa kembali email/password.');
    }
  };

  return (
    <div id="auth">
      <div className="container">
        <div className="row">
          <div className="col-md-5 col-sm-12 mx-auto">
            <div className="card pt-4">
              <div className="card-body">
                <div className="text-center mb-5">
                  <img src={logo} height="80" className="mb-4" alt="logo" />
                  <h3
                    style={{
                      fontFamily: '"Arial Black", "Arial", sans-serif',
                      fontWeight: 'bold',
                      color: '#1a237e', // Biru tua, bisa disesuaikan
                      textTransform: 'uppercase',
                      marginBottom: '0.2rem',
                    }}
                  >
                    PERUMDAM TKR
                  </h3>
                  <p
                    style={{
                      fontFamily: '"Arial Black", "Arial", sans-serif',
                      color: '#555555', // Abu-abu gelap
                      textTransform: 'uppercase',
                      fontWeight: 'normal',
                      fontSize: '0.9rem',
                      marginTop: '0',
                    }}
                  >
                    KABUPATEN TANGERANG
                  </p>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="form-group position-relative has-icon-left">
                    <label htmlFor="username">Email</label>
                    <div className="position-relative">
                      <input
                        type="text"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Masukkan email Anda"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <div className="form-control-icon">
                        <User size={16} />
                      </div>
                    </div>
                  </div>

                  <div className="form-group position-relative has-icon-left">
                    <div className="clearfix">
                      <label htmlFor="password">Password</label>
                      <Link to="/ForgotPassword" className="float-right">
                        <small>Lupa password?</small>
                      </Link>
                    </div>
                    <div className="form-group position-relative has-icon-left">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className="form-control"
                        id="password"
                        name="password"
                        placeholder="Masukkan Password Anda"
                        value={formData.password}
                        onChange={handleChange}
                      />
                      <div className="form-control-icon">
                        <Lock size={16} />
                      </div>
                      <div
                        style={{
                          position: 'absolute',
                          right: '15px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                      </div>
                    </div>
                  </div>

                  <div className="form-check clearfix my-4">
                    <div className="float-right"></div>
                  </div>

                  <div className="clearfix">
                    <button className="btn btn-primary float-right" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default Login;
